module.exports = __webpack_public_path__ + "img/apple-touch-icon.44c5350e.png";